import React, { useState } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";

import { GET_STANDS_CURSOR } from "graphql/query/stand-gql";

import GraphicStands from "components/graphic-stand";
import GraphicPacking from "components/graphic-packing";
import { Tables, TotalItems } from "components/layout";
import { Localize } from "components/service";
import { useBreadCrumbs } from "components/use-hooks";
import { Button } from 'antd';

import { gqlBuilderWhere } from 'utils';

const basePath = GraphicPacking.Const.basePath;
const tableHelper = GraphicStands.Helpers.TableChoise;

const GraphicPackingChoiseSubPage = ({ graphicPacking, loading, history }) => {
    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Graphic_Commissioning" }).props.children,
            path: `${ basePath }`
        },
        {
            label: graphicPacking?.title,
            path: `${ basePath }/${ graphicPacking?.id }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_GraphicChoise" }).props.children,
            path: `${ basePath }/${ graphicPacking?.id }/stands`
        }
    ];

    useBreadCrumbs(breadcrumbs);

    const routeUrl = `${ basePath }/${ graphicPacking?.id }${ GraphicStands.Const.basePath }`;

    const objOrderBy = [ { column: "ID", order: "DESC" } ];

    const filterTable = 'table-graphic-stand-choise';

    const graphicStandsFilters = JSON.parse(localStorage.getItem(`graphicStandsFilters-${ filterTable }_graphicPackingID-${ graphicPacking?.id }`));
    const graphicStandsSorting = JSON.parse(localStorage.getItem(`graphicStandsSorting-${ filterTable }_graphicPackingID-${ graphicPacking?.id }`));
    const graphicStandsSearch = JSON.parse(localStorage.getItem(`graphicStandsSearch-${ filterTable }_graphicPackingID-${ graphicPacking?.id }`));

    const [ searchText, setSearchText ] = useState(graphicStandsSearch);
    const [ filters, setFilters ] = useState(gqlBuilderWhere(graphicStandsFilters));
    const [ resetSorting, setResetSorting ] = useState(false);

    const { where: objFilter, whereEvents } = GraphicStands.Helpers.Filter.separateFilters({
        AND: [
            { column: 'SHELF_NUMBER', operator: 'IS_NOT_NULL' },
            { column: 'SHELF_NUMBER', operator: 'NEQ', value: '' },
            ...(!filters ? [] : Array.isArray(filters) ? filters : [ filters ])
        ]
    });

    return (
        <Tables.Cursor
            extraClass="table-graphic-stand-choise"
            tableLayout=""
            model="standsCursor"
            query={ GET_STANDS_CURSOR }
            currentObj={ { ...graphicPacking, graphicPackingId: graphicPacking?.id } }
            varSet={ {
                exclude_graphics_sent: true,
                perPage: 100,
                whereCrafts: {
                    column: 'TYPE',
                    value: "collect_graphics"
                },
                ...(whereEvents ? { whereEvents } : {})
            } }
            routeUrl={ routeUrl }
            searchText={ searchText }
            objFilter={ objFilter }
            objOrderBy={ graphicStandsSorting || objOrderBy }
            sortingName={ `graphicStandsSorting-${ filterTable }_graphicPackingID-${ graphicPacking?.id }` }
            tableHelper={ tableHelper }
            resetSorting={ resetSorting }
            filterTable={ filterTable }
        >
            { ({ pageInfo, model }) => (
                <>
                    <div className="table-action-bar">
                        <div className="col">
                            <GraphicStands.Filters.Table
                                excludeFields={ [ 'STATUS' ] }
                                graphicPacking={ graphicPacking }
                                setSearchText={ setSearchText }
                                setFilters={ setFilters }
                                filters={ filters }
                                graphicStandsFilters={ graphicStandsFilters }
                                setResetSorting={ setResetSorting }
                                filterTable={ filterTable }
                            />
                            <TotalItems
                                pageInfo={ pageInfo }
                            />
                        </div>
                        <div className="col">
                            <Button
                                type="primary"
                                onClick={ () => history.push(`${ basePath }/${ graphicPacking?.id }/packed-list`) }
                                style={ {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '4px'
                                } }
                            >
                                <Localize>GLOBAL.Button_Text_GoToGraphicPackingStands</Localize>
                                <ArrowRightOutlined style={ { fontSize: '16px', marginTop: '1px' } } />
                            </Button>
                        </div>
                    </div>
                </>
            ) }
        </Tables.Cursor>
    );
};

export default GraphicPackingChoiseSubPage;
